import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../common/common";
import { getJwt } from "./AuthService";

const apiEndpoint = API_BASE_URL_ENV() + "/landingPage";

export default class LoadingPageService extends BaseService {
	constructor() {
		http.setJwt(getJwt());
		super(apiEndpoint);
	}

	getList(type) {
		return http.get(`${apiEndpoint}/${type}`);
	}
}
